export const adjustAvailableForTask = ({ task, unitOfWork }) => {
  const available = task?.available?.[unitOfWork] || 0;
  const shrinkage = task?.shrinkage?.[unitOfWork] || 0;
  const plannedLeave = task?.plannedLeave?.[unitOfWork] || 0;
  const unplannedLeave = task?.unplannedLeave?.[unitOfWork] || 0;

  const availableAdjusted =
    available - shrinkage - plannedLeave - unplannedLeave;
  if (availableAdjusted <= 0) {
    return 0;
  }
  return availableAdjusted;
};
